import { render } from "./asset-position.vue?vue&type=template&id=f577ce98&scoped=true"
import script from "./asset-position.vue?vue&type=script&lang=js"
export * from "./asset-position.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-f577ce98"

export default script